var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Database } from "./sqlite";
import "reflect-metadata";
const METADATA_ENTITY = "sqlite_orm:entity";
const METADATA_COLUMS = "sqlite_orm:colums";
export function Entity(name) {
    return (clz) => {
        const tableName = name || clz.name;
        Reflect.defineMetadata(METADATA_ENTITY, {
            name: tableName,
        }, clz);
    };
}
export function Column(name) {
    return (target, propertyKey) => {
        const typeClz = Reflect.getMetadata("design:type", target, propertyKey);
        const columnName = name || propertyKey;
        let type = "TEXT";
        if (typeClz === Number) {
            type = "NUMERIC";
        }
        const columOptions = Reflect.getMetadata(METADATA_COLUMS, target.constructor);
        if (columOptions) {
            columOptions.push({
                name: columnName,
                type,
            });
        }
        else {
            Reflect.defineMetadata(METADATA_COLUMS, [
                {
                    name: columnName,
                    type,
                },
            ], target.constructor);
        }
    };
}
function PrimaryGeneratedColumn(name) {
    return (target, propertyKey) => {
        const typeClz = Reflect.getMetadata("design:type", target, propertyKey);
        if (typeClz !== Number) {
            throw new Error(`PrimaryGeneratedColumn type must be number`);
        }
        const columnName = name || propertyKey;
        const columOptions = Reflect.getMetadata(METADATA_COLUMS, target.constructor);
        if (columOptions) {
            columOptions.push({
                name: columnName,
                type: "INTEGER",
                primary: true,
                autoIncrement: true,
                nonull: true,
            });
        }
        else {
            Reflect.defineMetadata(METADATA_COLUMS, [
                {
                    name: columnName,
                    type: "INTEGER",
                    primary: true,
                    autoIncrement: true,
                    nonull: true,
                },
            ], target.constructor);
        }
    };
}
let Record = class Record {
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], Record.prototype, "id", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Record.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Record.prototype, "type", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Record.prototype, "extra", void 0);
Record = __decorate([
    Entity()
], Record);
export { Record };
export class SQLiteConnection {
    constructor(db) {
        this.db = db;
    }
    static connect(context, fileName) {
        return __awaiter(this, void 0, void 0, function* () {
            const db = yield Database.open(context, fileName);
            return new SQLiteConnection(db);
        });
    }
    getRepository(clz) {
        return __awaiter(this, void 0, void 0, function* () {
            const repository = new Repository(this.db, clz);
            yield repository.create();
            return repository;
        });
    }
}
export class Repository {
    constructor(db, clz) {
        this.db = db;
        this.tableOption = Reflect.getMetadata(METADATA_ENTITY, clz);
        this.columOptions = Reflect.getMetadata(METADATA_COLUMS, clz);
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            this.db.execute(`CREATE TABLE IF NOT EXISTS ${this.tableOption.name}  (
            ${this.columOptions
                .map((e) => `${e.name} ${e.type}${e.primary ? " PRIMARY KEY" : ""}${e.autoIncrement ? " AUTOINCREMENT" : ""}${e.nonull ? " NOT NULL" : ""} `)
                .join(",")}
       )`);
        });
    }
    query() {
        return __awaiter(this, void 0, void 0, function* () {
            const ret = yield this.db.executeQuery(`SELECT * FROM ${this.tableOption.name}`);
            return ret;
        });
    }
    update(entity) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    insert(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const columOptions = this.columOptions.filter((e) => !e.autoIncrement);
            const ret = yield this.db.executeQuery(`INSERT INTO ${this.tableOption.name} (${columOptions
                .map((e) => e.name)
                .join(",")}) VALUES (${new Array(columOptions.length)
                .fill("?")
                .join(",")})`, columOptions.map((e) => Reflect.get(entity, e.name)));
            return ret;
        });
    }
    delete(entity) {
        return __awaiter(this, void 0, void 0, function* () {
            const ret = yield this.db.executeUpdateDelete(`DELETE FROM ${this.tableOption.name} WHERE entity = ${entity}`);
            return ret;
        });
    }
}
//# sourceMappingURL=SQLiteORM.js.map